import decode from 'lean-he/decode'

/**
 * Decodes any named and numerical character references in text
 * @param {String} value
 */
export function htmlDecode (value) {
  if (value === null || value === undefined || value === '') return ''
  if (typeof value !== 'string') return decode(String(value))
  return decode(value)
}
